module.exports = __webpack_public_path__ + "media/images/flags/ss-b5e0cf5eb07905a6c1dbadf887cf3300.svg";